<div class="flex flex-wrap gap-small">
    @for (color of themeColors; track color) {
        <div
            class="flex align-items-center justify-content-center colorItem"
            [class.disabled]="disabled() || readonly()"
            [ngStyle]="color | colorStyle"
            (click)="selectColor($event, color)"
        >
            @if (color === value()) {
                <i class="checked pi pi-check"></i>
            }
        </div>
    }
    @if (withCustomColors()) {
        @for (color of customColors(); track $index; let index = $index) {
            <div
                class="flex-column justify-content-center align-items-center colorItem colorItem-custom"
                [class.colorItem-empty]="color === null"
                [class.disabled]="disabled() || readonly()"
                (click)="selectColor($event, color, index)"
                (contextmenu)="showCustomColorPicker($event, index)"
            >
                <p-colorPicker
                    [ngModel]="color"
                    (ngModelChange)="updateCustomColor(index, $event)"
                    [disabled]="disabled() || readonly()"
                    appendTo="body"
                    class="no-left-click"
                    (onHide)="persistCustomColors()"
                ></p-colorPicker>

                <i
                    class="custom pi pi-pencil"
                    [escape]="false"
                    tooltipStyleClass="colorItem-tooltip"
                    [pTooltip]="'inputs.color.tooltip' | translate"
                ></i>

                @if (color === value()) {
                    <i
                        class="checked pi pi-check"
                        [style.color]="value() | colorContrast"
                    ></i>
                }

                @if (color === null) {
                    <i class="add pi pi-plus"></i>
                }
            </div>
        }

        @if (!inColorsList()) {
            <div
                class="flex align-items-center justify-content-center colorItem"
                [ngStyle]="value() | colorStyle"
            >
                <i class="checked pi pi-check"></i>
            </div>
        }
    }
</div>
<app-input-error [errors]="errors()" [touched]="touched()"></app-input-error>
